$(function () {
  $('.js-subscribe').click(function () {
    window.open('https://www.facebook.com/akcentuk/', '_blank')
  })
})
